(() => {
  if (customElements.get('gh-tray-wrist-preview')) return;
  class WristPreview extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}], () => {});
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      this.stage = this.querySelector('.gh-wrist__stage');
      this.dragHint = this.querySelector('[data-drag-hint]');
      this.watch = this.querySelector('.gh-wrist__watch');
      this.setupWatchDrag();
      this.status = this.querySelector('[data-status]');
      this.camera = this.querySelector('[data-camera]');
      this.captureButton = this.querySelector('[data-capture]');
      this.saveButton = this.querySelector('[data-save]');
      this.retakeButton = this.querySelector('[data-retake]');
      this.shot = this.querySelector('[data-shot]');
      this.trayItems = this.querySelector('[data-tray-items]');
      this.trayStatus = this.querySelector('[data-tray-status]');
      this.originalProduct = this.productFromNode(this);
      this.activeProduct = this.originalProduct;
      this.productCache = new Map(this.originalProduct ? [[this.originalProduct.id, this.originalProduct]] : []);
      this.trayItems.addEventListener('click', event => {
        const button = event.target.closest('[data-tray-id]');
        if (button) this.switchWatch(button.dataset.trayId);
      });
      this.captureButton.addEventListener('click', () => this.capture());
      this.saveButton.addEventListener('click', () => this.save());
      this.retakeButton.addEventListener('click', () => this.retake());
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        this.stop();
        document.body.style.overflow = this.previousOverflow || '';
        document.querySelector('[data-tray-open]')?.focus();
      });
      this.querySelectorAll('[data-size]').forEach(button => button.addEventListener('click', () => this.size(Number(button.dataset.size))));
      this.camera.addEventListener('click', () => this.start());
      this.visibility = () => { if (document.hidden && this.dialog.open && !this.sharing) this.dialog.close(); };
      document.addEventListener('visibilitychange', this.visibility);
      this.pageHide = () => this.stop();
      window.addEventListener('pagehide', this.pageHide);
      try {
        const pending = JSON.parse(sessionStorage.getItem('gh_tray_ar_autostart') || 'null');
        if (pending && pending.id === this.originalProduct?.id && Date.now() - pending.at < 30000) {
          sessionStorage.removeItem('gh_tray_ar_autostart');
          queueMicrotask(() => this.openFromTray(pending.id));
        }
      } catch { sessionStorage.removeItem('gh_tray_ar_autostart'); }
    }
    openFromTray(id) {
      if (this.dialog.open || !this.originalProduct) return;
      this.dialog.showModal();
      this.previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.activateProduct(this.originalProduct);
      this.renderTray();
      this.trayStatus.textContent = '';
      this.setWatchPosition(0);
      this.size(15);
      if (id && id !== this.originalProduct.id) this.switchWatch(id);
      else this.trackEvent('gh_ar_open');
    }
    safeImage(value) {
      if (typeof value !== 'string' || !value.trim()) return '';
      try {
        const url = new URL(value, location.href);
        return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : '';
      } catch { return ''; }
    }
    productFromNode(node) {
      if (!node) return null;
      const d = node.dataset, image = node.querySelector('.gh-wrist__watch');
      const src = this.safeImage(image?.getAttribute('src'));
      const number = (value, min, max) => Number.isFinite(Number(value)) && Number(value) >= min && Number(value) <= max ? Number(value) : NaN;
      const caseWidth = number(d.caseWidth, 5, 100), caseRatio = number(d.caseRatio, .01, 1);
      if (!/^\d+$/.test(d.productId || '') || !/^[a-z0-9][a-z0-9-]*$/.test(d.productHandle || '') || !src || !Number.isFinite(caseWidth) || !Number.isFinite(caseRatio)) return null;
      return {id:d.productId, handle:d.productHandle, title:String(d.productName || '').slice(0, 200), src,
        caseWidth, caseRatio, caseLength:number(d.caseLength, 0, 120) || 0,
        caseHeightRatio:number(d.caseHeightRatio, 0, 1) || 0,
        centerX:Number.isFinite(number(d.centerX, 0, 1)) ? Number(d.centerX) : .5,
        centerY:Number.isFinite(number(d.centerY, 0, 1)) ? Number(d.centerY) : .5,
        maxWrist:number(d.maxWrist, 0, 30) || 0};
    }
    readTray() {
      try {
        const saved = JSON.parse(localStorage.getItem('gh_jewellery_tray_v1') || '[]');
        if (!Array.isArray(saved)) return [];
        return saved.slice(0, 6).filter(entry => entry?.cutout === true && /^\d+$/.test(String(entry.id)) && /^[a-z0-9][a-z0-9-]*$/.test(entry.handle || ''))
          .map(entry => ({id:String(entry.id), handle:entry.handle, title:String(entry.title || '').slice(0, 200), thumb:this.safeImage(entry.image)}))
          .filter(entry => entry.id !== this.originalProduct?.id);
      } catch { return []; }
    }
    renderTray() {
      if (!this.originalProduct) {
        this.querySelector('[data-tray-switcher]').hidden = true;
        return;
      }
      const saved = this.readTray();
      this.trayProducts = [{...this.originalProduct, thumb:this.originalProduct.src}, ...saved];
      this.querySelector('[data-tray-count]').textContent = saved.length ? `${saved.length} saved` : '';
      this.querySelector('[data-tray-hint]').hidden = saved.length > 0;
      const fragment = document.createDocumentFragment();
      for (const product of this.trayProducts) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gh-wrist__tray-item';
        button.dataset.trayId = product.id;
        button.setAttribute('aria-pressed', String(product.id === this.activeProduct?.id));
        button.setAttribute('aria-label', `Try ${product.title}`);
        if (product.thumb) {
          const image = document.createElement('img');
          image.src = product.thumb;
          image.alt = '';
          image.loading = 'lazy';
          button.append(image);
        }
        const name = document.createElement('span');
        name.textContent = product.title.split(/\s+/)[0] || 'Watch';
        button.append(name);
        fragment.append(button);
      }
      this.trayItems.replaceChildren(fragment);
    }
    activateProduct(product) {
      this.activeProduct = product;
      for (const key of ['caseWidth','caseRatio','caseLength','caseHeightRatio','centerX','centerY','maxWrist']) this.dataset[key] = String(product[key]);
      this.dataset.productId = product.id;
      this.dataset.productHandle = product.handle;
      this.dataset.productName = product.title;
      this.watch.src = product.src;
      this.watch.alt = product.title;
    }
    async fetchTrayProduct(entry) {
      if (this.productCache.has(entry.id)) return this.productCache.get(entry.id);
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const url = new URL(root + 'products/' + encodeURIComponent(entry.handle), location.origin);
      const previewId = new URLSearchParams(location.search).get('preview_theme_id');
      if (/^\d+$/.test(previewId || '')) url.searchParams.set('preview_theme_id', previewId);
      const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(12000)});
      if (!response.ok) throw new Error('Watch preview unavailable');
      const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = markup.querySelector('gh-wrist-preview[data-product-id="' + entry.id + '"]');
      const product = this.productFromNode(node);
      if (!product || product.handle !== entry.handle) throw new Error('Watch preview unavailable');
      this.productCache.set(entry.id, product);
      return product;
    }
    async switchWatch(id) {
      if (!this.dialog.open || this.capturePending || id === this.activeProduct?.id) return;
      const entry = this.trayProducts?.find(product => product.id === id);
      if (!entry) return;
      const token = this.switchRequest = (this.switchRequest || 0) + 1;
      this.switching = true;
      this.captureButton.disabled = true;
      this.trayStatus.textContent = 'Loading watch preview…';
      try {
        const product = await this.fetchTrayProduct(entry);
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.src = product.src;
        await image.decode();
        if (token !== this.switchRequest || !this.dialog.open) return;
        if (this.shotFile) this.retake();
        this.activateProduct(product);
        this.size(this.wristCm || 15);
        this.renderTray();
        this.trayStatus.textContent = product.title + ' selected.';
        this.trackEvent('gh_ar_open');
      } catch {
        if (token === this.switchRequest && this.dialog.open) this.trayStatus.textContent = 'Wrist preview is unavailable for this piece.';
      } finally {
        if (token === this.switchRequest) {
          this.switching = false;
          this.captureButton.disabled = false;
        }
      }
    }
    setupWatchDrag() {
      this.dragOffset = 0;
      this.updateWatchPosition();
      this.watch.draggable = false;
      this.watch.tabIndex = -1;
      this.watch.setAttribute('role', 'slider');
      this.watch.setAttribute('aria-label', 'Watch position along your wrist');
      this.watch.setAttribute('aria-valuemin', '0');
      this.watch.setAttribute('aria-valuemax', '100');
      this.watch.addEventListener('pointerdown', event => {
        if (!this.dialog.open || !this.stage.classList.contains('is-camera') || this.shotFile || this.capturePending || this.switching || !event.isPrimary || event.button !== 0) return;
        this.dismissDragHint();
        this.drag = {id: event.pointerId, x: event.clientX, offset: this.dragOffset};
        this.watch.setPointerCapture(event.pointerId);
        this.watch.classList.add('is-dragging');
        event.preventDefault();
      });
      this.watch.addEventListener('click', () => this.dismissDragHint());
      this.watch.addEventListener('pointermove', event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const width = this.stage.getBoundingClientRect().width;
        if (width) this.setWatchPosition(this.drag.offset + (event.clientX - this.drag.x) / width);
      });
      const finish = event => {
        if (this.drag?.id !== event.pointerId) return;
        this.drag = null;
        this.watch.classList.remove('is-dragging');
        if (this.watch.hasPointerCapture(event.pointerId)) this.watch.releasePointerCapture(event.pointerId);
      };
      this.watch.addEventListener('pointerup', finish);
      this.watch.addEventListener('pointercancel', finish);
      this.watch.addEventListener('lostpointercapture', finish);
      this.watch.addEventListener('keydown', event => {
        if (!this.dialog.open || !this.stage.classList.contains('is-camera') || this.shotFile || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.dismissDragHint();
        this.setWatchPosition(this.dragOffset + (event.key === 'ArrowLeft' ? -0.04 : 0.04));
      });
    }
    setWatchPosition(value) {
      this.dragOffset = Math.max(-0.28, Math.min(0, value));
      this.updateWatchPosition();
    }
    updateWatchPosition() {
      this.watch.style.setProperty('--gh-watch-drag-x', `${this.dragOffset * 100}%`);
      this.watch.setAttribute('aria-valuenow', String(Math.round(-this.dragOffset / 0.28 * 100)));
    }
    size(cm) {
      if (this.shotFile) this.retake();
      this.wristCm = cm;
      this.querySelectorAll('[data-size]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.size) === cm)));
      const wristWidth = cm * 10 * 0.35;
      const caseWidth = Number(this.dataset.caseWidth);
      const ratio = Number(this.dataset.caseRatio);
      this.watch.style.width = `${48 * caseWidth / wristWidth / ratio}%`;
      const caseLength = Number(this.dataset.caseLength);
      const heightRatio = Number(this.dataset.caseHeightRatio);
      this.watch.style.height = caseLength > 0 && heightRatio > 0
        ? `${100 * caseLength / wristWidth / heightRatio}%`
        : 'auto';
      this.watch.style.transform = `translate(-${Number(this.dataset.centerX) * 100}%, -${Number(this.dataset.centerY) * 100}%)`;
      const max = Number(this.dataset.maxWrist);
      this.querySelector('[data-fit]').textContent = max && cm > max ? this.messages.fit : '';
    }
    showDragHint() {
      this.hideDragHint();
      if (!this.dragHint) return;
      this.dragHint.hidden = false;
      this.dragHint.classList.add('is-visible');
      this.dragHintTimer = window.setTimeout(() => this.hideDragHint(), 2000);
    }
    dismissDragHint() {
      window.clearTimeout(this.dragHintTimer);
      this.dragHintTimer = null;
      if (!this.dragHint || this.dragHint.hidden || this.dragHintFade) return;
      if (typeof this.dragHint.animate !== 'function') {
        this.hideDragHint();
        return;
      }
      this.dragHintFade = this.dragHint.animate([
        {opacity: getComputedStyle(this.dragHint).opacity},
        {opacity: 0}
      ], {duration: 150, easing: 'ease-out', fill: 'forwards'});
      this.dragHintFade.onfinish = () => this.hideDragHint();
    }
    hideDragHint() {
      if (this.dragHintFade) {
        this.dragHintFade.onfinish = null;
        this.dragHintFade.cancel();
        this.dragHintFade = null;
      }
      window.clearTimeout(this.dragHintTimer);
      this.dragHintTimer = null;
      if (!this.dragHint) return;
      this.dragHint.hidden = true;
      this.dragHint.classList.remove('is-visible');
    }
    async start() {
      if (this.pending || this.stream) return;
      if (!navigator.mediaDevices?.getUserMedia || !window.isSecureContext) {
        this.status.textContent = this.messages.unavailable;
        return;
      }
      this.pending = true;
      const request = this.request = (this.request || 0) + 1;
      this.camera.disabled = true;
      this.status.textContent = this.messages.opening;
      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: { ideal: 'environment' }, width: { ideal: 1080 }, height: { ideal: 1080 } } });
        if (!this.isConnected || !this.dialog.open || request !== this.request) {
          stream.getTracks().forEach(track => track.stop());
          return;
        }
        this.stream = stream;
        this.video.srcObject = stream;
        await this.video.play();
        if (request !== this.request || !this.dialog.open) return;
        this.stage.classList.add('is-camera');
        this.watch.tabIndex = 0;
        this.camera.hidden = true;
        this.captureButton.hidden = false;
        this.status.textContent = this.messages.align;
        this.showDragHint();
        this.trackEvent('gh_ar_camera_start');
      } catch (error) {
        stream?.getTracks().forEach(track => track.stop());
        if (request === this.request && this.dialog.open) {
          this.stream = null;
          this.video.srcObject = null;
          this.status.textContent = error.name === 'NotAllowedError' ? this.messages.denied : this.messages.failed;
        }
      } finally {
        if (request === this.request) {
          this.pending = false;
          this.camera.disabled = false;
        }
      }
    }
    async capture() {
      if (!this.stream || this.capturePending || this.switching || !this.video.videoWidth) return;
      this.hideDragHint();
      this.capturePending = true;
      this.captureButton.disabled = true;
      const request = this.request;
      try {
        await this.watch.decode();
        if (request !== this.request || !this.dialog.open) return;
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 1080;
        const ctx = canvas.getContext('2d');
        const vw = this.video.videoWidth, vh = this.video.videoHeight;
        const side = Math.min(vw, vh);
        ctx.drawImage(this.video, (vw-side)/2, (vh-side)/2, side, side, 0, 0, 1080, 1080);
        const stage = this.stage.getBoundingClientRect();
        const watch = this.watch.getBoundingClientRect();
        const clip = this.querySelector('.gh-wrist__watch-clip').getBoundingClientRect();
        const k = 1080/stage.width;
        const overlay = document.createElement('canvas');
        overlay.width = overlay.height = 1080;
        const oc = overlay.getContext('2d');
        oc.drawImage(this.watch, (watch.left-stage.left)*k, (watch.top-stage.top)*k, watch.width*k, watch.height*k);
        const top = (clip.top-stage.top)*k, bottom = (clip.bottom-stage.top)*k;
        const fade = (bottom-top)*.04;
        const mask = oc.createLinearGradient(0,0,0,1080);
        mask.addColorStop(0,'transparent');
        mask.addColorStop(top/1080,'transparent');
        mask.addColorStop((top+fade)/1080,'#000');
        mask.addColorStop((bottom-fade)/1080,'#000');
        mask.addColorStop(bottom/1080,'transparent');
        mask.addColorStop(1,'transparent');
        oc.globalCompositeOperation = 'destination-in';
        oc.fillStyle = mask;
        oc.fillRect(0,0,1080,1080);
        ctx.drawImage(overlay,0,0);
        if (this.dataset.borderSrc) {
          const border = new Image();
          border.crossOrigin = 'anonymous';
          border.src = this.dataset.borderSrc;
          await border.decode();
          if (request !== this.request || !this.dialog.open) return;
          ctx.drawImage(border, 0, 0, 1080, 1080);
        }
        if (this.dataset.logoSrc) {
          const logo = new Image();
          logo.crossOrigin = 'anonymous';
          logo.src = this.dataset.logoSrc;
          await logo.decode();
          if (request !== this.request || !this.dialog.open) return;
          const markWidth = 350;
          const markHeight = markWidth * logo.naturalHeight / logo.naturalWidth;
          const markX = 1080 - 28 - markWidth;
          const markY = 1080 - 28 - markHeight;
          ctx.drawImage(logo, markX, markY, markWidth, markHeight);
        }
        const blob = await new Promise(resolve => canvas.toBlob(resolve,'image/jpeg',.94));
        if (!blob) throw new Error('Capture failed');
        if (request !== this.request || !this.dialog.open) return;
        this.shotFile = new File([blob], 'gilded-hour-wrist-preview.jpg', {type:'image/jpeg'});
        this.shotUrl = URL.createObjectURL(blob);
        this.shot.src = this.shotUrl;
        this.shot.hidden = false;
        this.stage.classList.add('is-captured');
        this.video.pause();
        this.captureButton.hidden = true;
        this.saveButton.hidden = this.retakeButton.hidden = false;
        this.status.textContent = this.messages.captured;
        this.trackCapture();
      } catch (error) {
        if (request === this.request && this.dialog.open) this.status.textContent = this.messages.capture_failed;
      } finally {
        this.capturePending = false;
        this.captureButton.disabled = false;
      }
    }
    trackCapture() {
      this.trackEvent('wrist_capture', 'gh_wrist_capture');
    }
    trackEvent(name, shopifyName = name) {
      const payload = {
        watch_id:this.dataset.productId,
        watch_name:this.dataset.productName,
        watch_handle:this.dataset.productHandle
      };
      if (window.ghWatchAnalytics) {
        window.ghWatchAnalytics.track(name, payload, shopifyName);
      } else {
        const queue = window.ghWatchEventQueue = window.ghWatchEventQueue || [];
        if (queue.length >= 20) queue.shift();
        queue.push([name, payload, shopifyName]);
      }
    }
    async save() {
      if (!this.shotFile || this.sharing) return;
      const file = this.shotFile;
      if (navigator.canShare?.({files:[file]})) {
        this.sharing = true;
        try {
          await navigator.share({files:[file]});
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        } finally {
          this.sharing = false;
        }
      }
      if (!this.shotUrl) return;
      const link = document.createElement('a');
      link.href = this.shotUrl;
      link.download = file.name;
      document.body.append(link);
      link.click();
      link.remove();
      this.status.textContent = this.messages.saved;
    }
    clearShot() {
      if (this.shotUrl) URL.revokeObjectURL(this.shotUrl);
      this.shotUrl = null;
      this.shotFile = null;
      this.shot.removeAttribute('src');
      this.shot.hidden = true;
      this.stage.classList.remove('is-captured');
      this.saveButton.hidden = this.retakeButton.hidden = true;
    }
    retake() {
      this.clearShot();
      if (this.stream) {
        this.video.play().catch(() => this.stop());
        this.captureButton.hidden = false;
      }
      this.status.textContent = this.messages.align;
    }
    stop() {
      this.hideDragHint();
      this.request = (this.request || 0) + 1;
      this.switchRequest = (this.switchRequest || 0) + 1;
      this.switching = false;
      this.stream?.getTracks().forEach(track => track.stop());
      this.stream = null;
      this.pending = false;
      this.clearShot();
      this.captureButton.hidden = true;
      this.video.pause();
      this.video.srcObject = null;
      this.stage.classList.remove('is-camera');
      this.watch.tabIndex = -1;
      this.camera.hidden = false;
      this.camera.disabled = false;
      this.captureButton.disabled = false;
      this.status.textContent = this.messages.align;
    }
    disconnectedCallback() {
      if (!this.ready) return;
      this.stop();
      if (this.dialog.open) document.body.style.overflow = this.previousOverflow || '';
      document.removeEventListener('visibilitychange', this.visibility);
      window.removeEventListener('pagehide', this.pageHide);
    }
  }
  customElements.define('gh-tray-wrist-preview', WristPreview);
})();

